import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars.
   */
  server: {
    ENV_NAME: z.string().optional(),
    AUTH_SECRET:
      process.env.NODE_ENV === "production"
        ? z.string()
        : z.string().optional(),
    DATABASE_URL: z.string().url(),
    GOOGLE_CLIENT_ID: z.string(),
    GOOGLE_CLIENT_SECRET: z.string(),
    SENDGRID_EMAIL_FROM: z.string(),
    AUTH_SENDGRID_KEY: z.string(),
    NSLS_AUTH_URL: z.string().url(),
    NSLS_AUTH_SECRET: z.string(),
    BRAINTRUST_PROJECT_NAME: z.string(),
    BRAINTRUST_GROUP_CHAT_PROJECT_NAME: z.string(),
    OPENAI_API_KEY: z.string(),
    SENDBIRD_WEBHOOK_SECRET: z.string(),
    SENDBIRD_APP_ID: z.string(),
    SENDBIRD_API_TOKEN: z.string(),
    SENDBIRD_API_URL: z.string().url(),
    ZAPIER_FEEDBACK_URL: z.string().url().optional(),
    TWILIO_ACCOUNT_SID: z.string().optional(),
    TWILIO_API_KEY_SID: z.string().optional(),
    TWILIO_API_KEY_SECRET: z.string().optional(),
    TWILIO_AUTH_TOKEN: z.string().optional(),
    NODE_ENV: z
      .enum(["development", "test", "production"])
      .default("development"),
  },

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    // NEXT_PUBLIC_CLIENTVAR: z.string(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string(),
    NEXT_PUBLIC_SENDBIRD_APP_ID: z.string().optional(),
    NEXT_PUBLIC_SENDBIRD_API_TOKEN: z.string().optional(),
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   */
  runtimeEnv: {
    ENV_NAME: process.env.ENV_NAME,
    AUTH_SECRET: process.env.AUTH_SECRET,
    DATABASE_URL: process.env.DATABASE_URL,
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
    GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET,
    NODE_ENV: process.env.NODE_ENV,
    SENDGRID_EMAIL_FROM: process.env.SENDGRID_EMAIL_FROM,
    AUTH_SENDGRID_KEY: process.env.AUTH_SENDGRID_KEY,
    NSLS_AUTH_URL: process.env.NSLS_AUTH_URL,
    NSLS_AUTH_SECRET: process.env.NSLS_AUTH_SECRET,
    BRAINTRUST_PROJECT_NAME: process.env.BRAINTRUST_PROJECT_NAME,
    BRAINTRUST_GROUP_CHAT_PROJECT_NAME: process.env.BRAINTRUST_GROUP_CHAT_PROJECT_NAME,
    OPENAI_API_KEY: process.env.OPENAI_API_KEY,
    SENDBIRD_WEBHOOK_SECRET: process.env.SENDBIRD_WEBHOOK_SECRET,
    ZAPIER_FEEDBACK_URL: process.env.ZAPIER_FEEDBACK_URL,
    SENDBIRD_APP_ID: process.env.SENDBIRD_APP_ID,
    SENDBIRD_API_TOKEN: process.env.SENDBIRD_API_TOKEN,
    SENDBIRD_API_URL: process.env.SENDBIRD_API_URL,
    TWILIO_ACCOUNT_SID: process.env.TWILIO_ACCOUNT_SID,
    TWILIO_API_KEY_SID: process.env.TWILIO_API_KEY_SID,
    TWILIO_API_KEY_SECRET: process.env.TWILIO_API_KEY_SECRET,
    TWILIO_AUTH_TOKEN: process.env.TWILIO_AUTH_TOKEN,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_SENDBIRD_APP_ID: process.env.NEXT_PUBLIC_SENDBIRD_APP_ID ?? "",
    NEXT_PUBLIC_SENDBIRD_API_TOKEN: process.env.NEXT_PUBLIC_SENDBIRD_API_TOKEN ?? "",
  },
  /**
   * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation. This is especially
   * useful for Docker builds.
   */
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  /**
   * Makes it so that empty strings are treated as undefined. `SOME_VAR: z.string()` and
   * `SOME_VAR=''` will throw an error.
   */
  emptyStringAsUndefined: true,
});
